<script setup lang="ts">
import Icon from '~/components/global/Icon.vue'

const { t } = useI18n()
const router = useRouter()

const props = defineProps<{
  backText?: string | null
  backTextShort?: string | null
  backLink?: string | ReturnType<typeof useLocaleLink>
}>()

function onBackClick() {
  if (props.backLink) {
    return navigateTo(props.backLink)
  }

  router.back()
}

const backText = computed(() => {
  if (!props.backText) {
    return t('backButton.justBack')
  }

  return t('backButton.label', { _0: props.backText })
})

const backTextShort = computed(() => {
  if (!props.backTextShort) {
    return t('backButton.justBack')
  }

  return t('backButton.label', { _0: props.backTextShort })
})
</script>

<template>
  <button class="c-link c-link--has-icon" @click="onBackClick">
    <Icon name="arrow-left" />

    <template v-if="backTextShort">
      <span class="_sm:visible">{{ backText }}</span>
      <span class="_sm:hidden">{{ backTextShort }}</span>
    </template>

    <template v-else>
      <span>{{ $t('backButton.label', { _0: backText }) }}</span>
    </template>
  </button>
</template>

<style lang="scss" scoped>
.c-link {
  font-size: 16px;
  gap: 8px;

  .ico {
    font-size: 24px;
  }
}
</style>
